import { useState } from "react";
import ProductCard from "../ui/ProductCard";
// import products from "../../data/products";
import products from "../data/products";

const filters = [
  "All",
  "Books",
  "Coffee",
  "Apparel",
  "Greens",
];

export default function BestSellers() {

  const [active, setActive] = useState("All");

  const filtered =
    active === "All"
      ? products
      : products.filter(
          (product) => product.category === active
        );

  return (
    <section className="bg-[#FAFCF9] py-28">

      <div className="mx-auto max-w-7xl px-6">

        <div className="flex flex-col items-center justify-between gap-8 lg:flex-row">

          <div>

            <span className="uppercase tracking-[4px] text-[#6B8E5F] text-sm">
              Featured Products
            </span>

            <h2 className="mt-3 text-5xl font-semibold">
              Best Sellers
            </h2>

          </div>

          {/* Filter */}

          <div className="flex flex-wrap justify-center gap-4">

            {filters.map((item) => (

              <button
                key={item}
                onClick={() => setActive(item)}
                className={`rounded-full px-6 py-3 transition

                ${
                  active === item
                    ? "bg-[#6B8E5F] text-white"
                    : "bg-white shadow hover:bg-[#6B8E5F] hover:text-white"
                }`}
              >
                {item}
              </button>

            ))}

          </div>

        </div>

        {/* Grid */}

        <div className="mt-16 grid gap-8 md:grid-cols-2 xl:grid-cols-4">

          {filtered.map((product) => (

            <ProductCard
              key={product.id}
              {...product}
            />

          ))}

        </div>

      </div>

    </section>
  );
}